import React, { useState, useEffect } from 'react'; // Added useEffect
import PessoaList from '../components/PessoaList';
import PessoaForm from '../components/PessoaForm';
import { Container, Typography, Box, Button, IconButton, Collapse, TextField } from '@mui/material'; // Added IconButton, Collapse, TextField
import AddIcon from '@mui/icons-material/Add';
import FilterListIcon from '@mui/icons-material/FilterList'; // New import
import { actionButtonSx, filterCardSx, pageTitleSx } from '../styles/uiTokens';

function PessoasPage() {
  const [refreshList, setRefreshList] = useState(false);
  const [editingPessoa, setEditingPessoa] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showFilters, setShowFilters] = useState(false); // State for filter visibility

  // Filter states
  const [filterNome, setFilterNome] = useState('');
  const [filterCnpj, setFilterCnpj] = useState('');
  const [filterCpf, setFilterCpf] = useState('');
  const [filterRg, setFilterRg] = useState('');

  // Effect to trigger list refresh when filters change
  useEffect(() => {
    setRefreshList(prev => !prev);
  }, [filterNome, filterCnpj, filterCpf, filterRg]);


  const handlePessoaAdded = (pessoa) => {
    setRefreshList(prev => !prev);
    if (pessoa?.id) {
      setEditingPessoa(pessoa);
      setShowForm(true);
      return;
    }

    setEditingPessoa(null);
    setShowForm(false);
  };

  const handleEditPessoa = (pessoa) => {
    setEditingPessoa(pessoa);
    setShowForm(true);
  };

  const handleCancelEditPessoa = () => {
    setEditingPessoa(null);
    setShowForm(false);
  };

  const handlePessoaDeleted = () => {
    setRefreshList(prev => !prev);
  };

  const handleShowForm = () => {
    setEditingPessoa(null);
    setShowForm(true);
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4" gutterBottom sx={pageTitleSx}>
          Gerenciar Pessoas
        </Typography>
        <Box> {/* Group buttons */}
          {!showForm && ( // Only show these buttons if form is NOT active
            <>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleShowForm}
                sx={{ ...actionButtonSx, mr: 1 }}
              >
                Adicionar Pessoa
              </Button>
              <IconButton
                onClick={() => setShowFilters(prev => !prev)}
                aria-label="toggle filters"
                sx={{ color: 'primary.main' }}
              >
                <FilterListIcon />
              </IconButton>
            </>
          )}
        </Box>
      </Box>

      {!showForm && ( // Only show filters if form is NOT active
        <Collapse in={showFilters}>
          <Box sx={filterCardSx}>
            <Typography variant="h6" gutterBottom>Filtros</Typography>
            <TextField
              label="Nome"
              fullWidth
              margin="normal"
              value={filterNome}
              onChange={(e) => setFilterNome(e.target.value)}
            />
            <TextField
              label="CPF"
              fullWidth
              margin="normal"
              value={filterCpf}
              onChange={(e) => setFilterCpf(e.target.value)}
            />
            <TextField
              label="CNPJ"
              fullWidth
              margin="normal"
              value={filterCnpj}
              onChange={(e) => setFilterCnpj(e.target.value)}
            />
            <TextField
              label="RG"
              fullWidth
              margin="normal"
              value={filterRg}
              onChange={(e) => setFilterRg(e.target.value)}
            />
          </Box>
        </Collapse>
      )}

      {showForm && (
        <PessoaForm
          onPessoaAdded={handlePessoaAdded}
          initialData={editingPessoa}
          onCancelEdit={handleCancelEditPessoa}
        />
      )}

      {!showForm && (
        <PessoaList
          refresh={refreshList}
          onEdit={handleEditPessoa}
          onPessoaDeleted={handlePessoaDeleted}
          filterNome={filterNome}
          filterCnpj={filterCnpj}
          filterCpf={filterCpf}
          filterRg={filterRg}
        />
      )}
    </Container>
  );
}

export default PessoasPage;
